import Model from '@/core/models/Model';

export default class Qualification extends Model {
  resource() {
    return 'app/qualifications';
  }
}
